import { createFileRoute, redirect } from '@tanstack/react-router';

// Kept for saved tabs and links to the old routine URL
export const Route = createFileRoute(
  '/_authenticated/routine-chats/$routineId'
)({
  beforeLoad({ params }) {
    throw redirect({
      to: '/routines/$routineId',
      params: { routineId: params.routineId },
      search: true,
      replace: true,
    });
  },
});
